import React from "react";
import { Switch, Slider } from "./ToggleSwitchStyled";

export default function ToggleSwitch({ name, isOn, sound, save }) {
  return (
    <label
      style={{
        display: "flex",
        justifyContent: "space-between",
        // alignItems: "center",
        cursor: "pointer"
      }}
      onMouseUp={() => {
        // sound();
        save();
      }}
    >
      <h3
        style={{
          cursor: "pointer"
        }}
      >
        {name}
      </h3>
      <Switch className="switch">
        <input defaultChecked={isOn} type="checkbox" />
        <Slider className="slider" />
      </Switch>
    </label>
  );
}
